import React from 'react';
import { HiOutlineMail } from 'react-icons/hi';
import { FaSlack, FaWhatsapp } from 'react-icons/fa';
import { ChannelType, CHANNEL_ADAPTER, CHANNEL_LABELS } from '../../../../../types/communication';

interface ChannelVisual {
    icon: React.ComponentType<{ size?: number; className?: string }>;
    tile: string;
    text: string;
    ring: string;
    tagline: string;
    example: string;
}

export const CHANNEL_VISUALS: Record<ChannelType, ChannelVisual> = {
    EMAIL: {
        icon: HiOutlineMail,
        tile: 'bg-sky-100 text-sky-700 dark:bg-sky-900/50 dark:text-sky-300',
        text: 'text-sky-700 dark:text-sky-300',
        ring: 'ring-sky-500',
        tagline: 'E-mail com layout, assunto e anexos para clientes e parceiros.',
        example: 'Ex.: aviso de cessão com boleto em anexo',
    },
    INTERNAL_MESSAGE: {
        icon: FaSlack,
        tile: 'bg-violet-100 text-violet-700 dark:bg-violet-900/50 dark:text-violet-300',
        text: 'text-violet-700 dark:text-violet-300',
        ring: 'ring-violet-500',
        tagline: 'Alerta para os times internos, publicado num canal de chat.',
        example: 'Ex.: lote de duplicatas finalizado com falhas',
    },
    EXTERNAL_MESSAGE: {
        icon: FaWhatsapp,
        tile: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300',
        text: 'text-emerald-700 dark:text-emerald-300',
        ring: 'ring-emerald-500',
        tagline: 'Mensagem para o cliente usando um modelo já aprovado no WhatsApp.',
        example: 'Ex.: confirmação de duplicata pelo sacado',
    },
};

export const ChannelTile: React.FC<{ channel: ChannelType; size?: 'sm' | 'md' | 'lg' }> = ({ channel, size = 'md' }) => {
    const visual = CHANNEL_VISUALS[channel] ?? CHANNEL_VISUALS.INTERNAL_MESSAGE;
    const Icon = visual.icon;
    const box = size === 'sm' ? 'w-7 h-7' : size === 'lg' ? 'w-12 h-12' : 'w-9 h-9';
    const iconSize = size === 'sm' ? 14 : size === 'lg' ? 24 : 18;
    return (
        <span className={`inline-flex items-center justify-center rounded-lg shrink-0 ${box} ${visual.tile}`} title={CHANNEL_LABELS[channel] ?? channel}>
            <Icon size={iconSize} />
        </span>
    );
};

export const ChannelPill: React.FC<{ channel: ChannelType }> = ({ channel }) => {
    const visual = CHANNEL_VISUALS[channel] ?? CHANNEL_VISUALS.INTERNAL_MESSAGE;
    const Icon = visual.icon;
    return (
        <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${visual.tile}`}>
            <Icon size={12} />
            {CHANNEL_LABELS[channel] ?? channel}
            <span className="opacity-60">· {CHANNEL_ADAPTER[channel] ?? ''}</span>
        </span>
    );
};
